// NATIVE
import * as React from 'react';

// INSTALLED
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// CUSTOM
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../SnackAlert';
import { timeToClosedToast } from '../../../commons';
import MultipleSnackbars from '../../MultipleSnackbars';
import { storeCreateCargo } from '../../../store/cargos';
import { closeSessionGlobal, hasPemissions } from '../../../commons/utils';
import { CreateCargo } from '../../cargos/crear/CreateCargo';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import validationSchema from '../../turnosEmpleados/configuracionTurnos/crear/formModels/validationSchema';
import createConfiguracionTurnosFormModel from '../../turnosEmpleados/configuracionTurnos/crear/formModels/createConfiguracionTurnosFormModel';
import formInitialValues from '../../turnosEmpleados/configuracionTurnos/crear/formModels/formInitialValues';
import { GeneracionTurnos } from '../../turnosEmpleados';
import { storeConfiguracionTurno } from '../../../store/shifts_employees';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const CreateModalTurnosEmpleados = (props: any) => {
  const dispatch = useDispatch();

  // PROPS
  const { open, handleCloseDialog, buttons = false } = props;

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [btnText, setBtnText] = React.useState('Crear Configuracion');

  const [percentaje, setPercentaje] = React.useState(0);
  const [data, setMsgErrors] = React.useState([]);
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [message_alert_snack, setMessageAlertSnack] = React.useState('');
  const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

  // USE STATE
  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);
  const [txtBtnCrearConfiguracion, setTxtBtnCrearConfiguracion] =
    React.useState<string>('Crear Configuracion');

  // CONST FUNCTIONS
  const handleCloseModal = () => {
    handleCloseDialog(false);
  };

  // DATA MODELS
  const { formId, formField } = createConfiguracionTurnosFormModel;
  const currentValidationSchema = validationSchema[0];

  const _handleSubmit = async (values: any, actions: any) => {
    console.log('values ', values);
    console.log('actions ', actions);
    const response = await dispatch(storeConfiguracionTurno(values, setPercentaje));
    return false;
    const havePermissions = await hasPemissions(
      'modulo.thumano',
      'modulo.turnosempleados',
      'create',
      'modulo.generarconfiguracion'
    );

    if (!havePermissions) {
      await validateLsPermissions('No tienes pemisos para (Crear) novedad turno.');

      return false;
    }

    setIsSubmitting(true);
    setBtnText('Un momento...');

    actions.setSubmitting(true);

    // const response = await dispatch( storeConfiguracionTurno(values, setPercentaje) );

    const result = await validateResponseCreate(response, ' (Editar Tipo Novedad.) ');

    setBtnText('Crear Configuracion');
    setIsSubmitting(false);

    if (!result) {
      return false;
    }

    if (response.ok) {
      const errors: any = {
        msg: response.message,
        status: 'success',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseDialog(false);
      return false;
    }
  };

  const validateLsPermissions = async (message: string) => {
    const errors: any = {
      msg: message,
      status: 'error',
    };

    await setMsgSnack(errors);
    await setAlertSnack(true);
  };

  const validateResponseCreate = async (response: any, textActionConcat: string) => {
    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      await handleCloseDialog(false);
      setModalSessionExpired(true);
      return false;
    }

    // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION
    if (!response.ok && response.code == 403) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 403 EL DATO YA SE ENCUENTRA REGISTRADO
    if (!response.ok && response.code == 409) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO
    if (!response.ok && response.code == 400) {
      const errors: any = [];

      response.errors.forEach((element: any) => {
        errors.push({
          type: 'error',
          text: element,
        });
      });

      setMessagesAlerts(errors);
      return false;
    }

    return true;
  };

  return (
    <React.Fragment>
      <ModalSessionExpired open={modalSessionExpired} />

      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />

      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <BootstrapDialog
        onClose={handleCloseModal}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'md'}
        sx={{
          '& .MuiDialog-paper': {
            height: '600px', // Alto personalizado del modal
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Crear Configuracion Para Turnos
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseModal}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers>
          <Formik
            initialValues={formInitialValues}
            validationSchema={currentValidationSchema}
            onSubmit={_handleSubmit}
          >
            <Form id={formId}>
              <GeneracionTurnos formField={formField} />
              <Button
                disabled={isSubmiting}
                style={{ float: 'right' }}
                sx={{ margin: 2 }}
                type="submit"
                variant="contained"
                color={'primary'}
              >
                {txtBtnCrearConfiguracion}
              </Button>
            </Form>
          </Formik>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'flex-end' }}></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
